import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { useGetAuthQuery } from "../features/api";

/**
 * 権限なしの場合トップページへ遷移の共通処理Hook
 *
 * @param permission 許可する権限
 * @param userType 許可するユーザタイプ
 */
export const useAuthenticationHook = (
  permission: string,
  userType?: string
) => {
  // 権限取得
  const { permissions, companyType } = useGetAuthQuery(undefined, {
    selectFromResult: ({ data }) => ({
      permissions: data?.permissions,
      companyType: data?.companyType,
    }),
  });

  const navigate = useNavigate();

  const [authenticated, setAuthenticated] = useState<boolean>(false);

  // 権限なしの場合トップページへ遷移
  useEffect(() => {
    if (permissions !== undefined) {
      if (permissions.includes(permission)) {
        if (userType) {
          if (companyType === userType) {
            setAuthenticated(true);
          } else navigate("/");
        } else setAuthenticated(true);
      } else {
        navigate("/");
      }
    }
  }, [permission, userType, permissions, companyType, navigate]);

  return authenticated;
};
